<div [@pageLoader]="state$ | async"></div>
